module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hgf0fs/tc-custom/9781504098823.jpg?1728169120212",
      "alt": "This image is the cover for the book Anagramist, Feyer and Drake"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Anagramist, Feyer and Drake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A damaged woman. A tormented man. Can they work together to stop a cold-blooded killer? ")]), _c('br'), _c('br'), _vm._v(" DCI Samantha Feyer has been abused and ostracized by her former colleagues. Meanwhile, Wes Drake is tortured by cryptic emails relating to a series of violent murders."), _c('br'), _c('br'), _vm._v(" Drawn together by circumstance, Feyer and Drake are soon tasked with tracking down an enigmatic murderer who callously slaughters his victims."), _c('br'), _c('br'), _vm._v(" Can Drake’s methodical mind, coupled with Feyer’s unflinching investigative skills, unmask the killer and bring him to justice?"), _c('br'), _c('br'), _vm._v(" As they are drawn deeper into a nightmare journey of personal suffering, it’s unclear who, if anyone, might make it out alive . . ."), _c('br'), _c('br'), _vm._v(" “A very good read. The right balance of crime and human interest.” "), _c('i', [_vm._v("—")]), _vm._v("Maureen Vincent-Northam, author of "), _c('i', [_vm._v("Black Dog’s Treasure")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David W Robinson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0